/**
 * Bedtime story library — 10 free Hindi regional myths in v0.
 * Audio loaded on demand; metadata always cached. Premium 50+ stub.
 */

export interface BedtimeStory {
  id: string;
  title_hi: string;
  title_en: string;
  duration_min: number;
  tradition: 'krishna_leela' | 'hanuman_chalisa' | 'birbal' | 'panchatantra' | 'jataka' | 'akbar_birbal' | 'tenali_raman' | 'sufi';
  narrator_hi: string;
  audio_src: string | null;
  text_excerpt_hi: string;
  text_excerpt_en: string;
  premium: boolean;
}

export const STORIES: readonly BedtimeStory[] = [
  {
    id: 'kalia-mardan',
    title_hi: 'कालिया मर्दन',
    title_en: 'Kalia Mardan',
    duration_min: 11,
    tradition: 'krishna_leela',
    narrator_hi: 'पारंपरिक · वृंदावन शैली',
    audio_src: null,
    text_excerpt_hi: 'यमुना के पानी में जब काला नाग कालिया रहता था, बाल कृष्ण उसकी सौ फनों पर नाचे और जल को निर्मल किया...',
    text_excerpt_en: 'In the dark waters of Yamuna, when the serpent Kalia coiled, the boy Krishna danced on his hundred hoods until the river ran pure again.',
    premium: false,
  },
  {
    id: 'hanuman-lanka',
    title_hi: 'हनुमान की लंका यात्रा',
    title_en: "Hanuman's Lanka",
    duration_min: 14,
    tradition: 'hanuman_chalisa',
    narrator_hi: 'पारंपरिक · रामायण शैली',
    audio_src: null,
    text_excerpt_hi: 'सौ योजन सागर लांघ कर हनुमान जी ने लंका में प्रवेश किया, और एक छोटी सी मक्खी जैसे रूप में राक्षसी सुरक्षा को मात दी...',
    text_excerpt_en: 'Leaping a hundred yojanas across the ocean, Hanuman shrank to the size of a fly to slip past the demon guards of Lanka.',
    premium: false,
  },
  {
    id: 'birbal-khichdi',
    title_hi: 'बीरबल की खिचड़ी',
    title_en: "Birbal's Khichdi",
    duration_min: 7,
    tradition: 'akbar_birbal',
    narrator_hi: 'पारंपरिक · आगरा दरबार',
    audio_src: null,
    text_excerpt_hi: 'अकबर ने पूछा, "क्या कोई इतनी ठंड में यमुना में रात भर खड़ा रह सकता है?" बीरबल ने एक गरीब आदमी को खड़ा कराया, फिर खिचड़ी की मटकी छत पर रखी...',
    text_excerpt_en: 'When Akbar asked if a man could stand all night in the icy Yamuna, Birbal proved it with a pot of khichdi placed on a distant roof.',
    premium: false,
  },
  {
    id: 'sherni-aur-bandar',
    title_hi: 'शेरनी और बंदर',
    title_en: 'Lioness and the Monkey',
    duration_min: 9,
    tradition: 'panchatantra',
    narrator_hi: 'पारंपरिक · पंचतंत्र',
    audio_src: null,
    text_excerpt_hi: 'जंगल में एक शेरनी अपने बच्चे को छोड़कर शिकार पर निकली, और एक चालाक बंदर ने बच्चे की रक्षा की...',
    text_excerpt_en: 'A lioness left her cub in the forest, and a clever monkey kept it safe until she returned with the night.',
    premium: false,
  },
  {
    id: 'tenali-vada',
    title_hi: 'तेनाली का वड़ा',
    title_en: "Tenali's Vada",
    duration_min: 8,
    tradition: 'tenali_raman',
    narrator_hi: 'पारंपरिक · विजयनगर',
    audio_src: null,
    text_excerpt_hi: 'राजा कृष्णदेवराय ने अपने दरबारियों को वड़े बनवाए, पर तेनाली राम ने ऐसा वड़ा बनाया जिसने सबको चुप कर दिया...',
    text_excerpt_en: 'When the king commanded his courtiers to make vada, Tenali Raman cooked one that silenced the entire court.',
    premium: false,
  },
  {
    id: 'jataka-monkey-king',
    title_hi: 'वानर राजा की कुर्बानी',
    title_en: 'The Monkey King',
    duration_min: 12,
    tradition: 'jataka',
    narrator_hi: 'पारंपरिक · बौद्ध जातक',
    audio_src: null,
    text_excerpt_hi: 'एक वानर राजा ने अपने आम के पेड़ की रक्षा के लिए अपने शरीर का पुल बनाया, ताकि उसके परिवार के सब बंदर सुरक्षित नदी पार कर सकें...',
    text_excerpt_en: 'A monkey king made his own body a bridge so that every monkey of his clan could cross the river to safety.',
    premium: false,
  },
  {
    id: 'shams-tabriz',
    title_hi: 'शम्स तब्रेज़ी की चुप्पी',
    title_en: "Shams' Silence",
    duration_min: 13,
    tradition: 'sufi',
    narrator_hi: 'पारंपरिक · सूफ़ी मार्ग',
    audio_src: null,
    text_excerpt_hi: 'जब रूमी पहली बार शम्स से मिले, तो शब्द रुक गए और सिर्फ़ साँस का संगीत बचा...',
    text_excerpt_en: 'When Rumi first met Shams, words fell silent and only the music of breathing remained.',
    premium: false,
  },
  {
    id: 'krishna-makhan',
    title_hi: 'कृष्ण और मक्खन',
    title_en: 'Krishna and the Butter',
    duration_min: 6,
    tradition: 'krishna_leela',
    narrator_hi: 'पारंपरिक · वृंदावन',
    audio_src: null,
    text_excerpt_hi: 'गोपियों ने अपनी मटकियाँ छत पर रखीं, पर बाल कृष्ण ने अपने सखाओं के साथ छत पर चढ़कर एक एक मटकी फोड़ी...',
    text_excerpt_en: 'The gopis hid their butter pots high on the rafters, but Krishna and his friends climbed and broke them, one by one.',
    premium: false,
  },
  {
    id: 'birbal-cold-coin',
    title_hi: 'बीरबल और ठंडी मुहर',
    title_en: "Birbal's Cold Coin",
    duration_min: 7,
    tradition: 'akbar_birbal',
    narrator_hi: 'पारंपरिक · आगरा',
    audio_src: null,
    text_excerpt_hi: 'अकबर ने एक मुहर सरदी की रात में नदी में फेंकी और कहा, "जो भी इसे ढूंढ लाए, उसे एक हज़ार सोना मिलेगा।"...',
    text_excerpt_en: 'On a freezing night Akbar threw a gold coin into the river and offered a thousand pieces of gold to whoever could fetch it back.',
    premium: false,
  },
  {
    id: 'panchatantra-blue-jackal',
    title_hi: 'नीला सियार',
    title_en: 'The Blue Jackal',
    duration_min: 10,
    tradition: 'panchatantra',
    narrator_hi: 'पारंपरिक · पंचतंत्र',
    audio_src: null,
    text_excerpt_hi: 'एक भूखा सियार रंग की नांद में गिर गया और नीला हो गया, तो जंगल के सारे जानवरों ने उसे राजा मान लिया...',
    text_excerpt_en: 'A hungry jackal fell into a dyer\'s vat of indigo, emerged blue, and convinced the entire forest to crown him king.',
    premium: false,
  },
];

export const PREMIUM_STORY_COUNT = 50;

export function freeStories(): readonly BedtimeStory[] {
  return STORIES.filter((s) => !s.premium);
}

export function storyById(id: string): BedtimeStory | null {
  return STORIES.find((s) => s.id === id) ?? null;
}
